@use "@fukuri-admins/ui/layout" as *;

.TableSearch {
  background-color: $NATURAL_100;
  padding: 24px 24px 32px 24px;
  margin-bottom: 16px;

  &__SearchContainer {
    margin-top: 16px;
    display: flex;
    gap: 8px;

    &__SearchButton {
      padding: 10px 24px;
      background-color: $NATURAL_600;
      border-radius: 6px;
      color: $White;
    }
    &__ClearButton {
      padding: 10px 24px;
      background-color: $White;
      border: 1px solid $NATURAL_600;
      border-radius: 6px;
      color: $NATURAL_600;
    }
  }
}

@media (max-width: 600px) {
  .TableSearch {
    padding: 12px 12px 16px 12px;

    &__SearchContainer {
      flex-direction: column;
      gap: 8px;

      &__SearchButton,
      &__ClearButton {
        padding: 8px 16px;
      }
    }
  }
}
